import { GetAccountsResponse } from '@iwoca/lapi-client/edge';

export function selectLatestIwocaPayFormalOffer(
  data: GetAccountsResponse | null,
) {
  const accounts = data?.data?.accounts;

  if (!accounts) return null;

  for (const account of accounts) {
    if (!account.formal_offers) continue;

    // assume here it's going to be just one formal offer
    for (const formalOffer of account.formal_offers) {
      if (formalOffer.product_type !== 'iwocapay') continue;

      return formalOffer;
    }
  }

  return null;
}
